module.exports = __webpack_public_path__ + "assets/img/index-company3.9ecca939.jpg";